// @flow
import * as React from "react";
import { useState } from "react";
import { FileGet, FileSend } from "../libs/fileHandler";
import { RoomMessageType } from "../proto/Global_pb";
import { FILE_BASEURL } from "../constants/webservices";

let fileInstanceGlobal: FileSend;
let interval;
type Props = {};
export const GroundFileUpload = (props: Props) => {
  const [logs, setLogs] = useState<string[]>([]);
  const [uploadedFileToken, setUploadedFileToken] = useState<string>();

  const onClickDownload = () => {
    if (!uploadedFileToken) return;
    const fileGet = new FileGet(
      {
        token: uploadedFileToken,
        mime: fileInstanceGlobal.getRawFile().type,
        size: fileInstanceGlobal.getRawFile().size,
        publicUrl: "",
      },
      0
    );
    fileGet.onFinish((token) => {
      alert("FileDownloaded " + token);
    });
    fileGet.onCatch(() => {
      alert("FileDownloaded Errored");
    });
    fileGet.onProgress((percent) => {
      setLogs(["downloading " + percent + "%"]);
    });
    fileGet.start();
  };

  const onChangeFile = (e: any) => {
    const file: File = e.target.files[0];
    const fileInstance = new FileSend(file, RoomMessageType.FILE);
    setLogs([]);
    fileInstance.onProgress((progress) =>
      setLogs((log) => [
        `
      <div class='my-2 bg-green-200'>${progress ? `${progress}% uploaded...` : "initialized!"} 
        </hr>
      </div>
    `,
        ...log,
      ])
    );
    fileInstance.onCatch(() => {
      alert("Errorrrrrr");
    });
    fileInstance.onFileSaved((token) => {
      setUploadedFileToken(token);
    });
    fileInstance.onFinish((token) => {
      fileInstanceGlobal = fileInstance;
      setUploadedFileToken(token);
      setTimeout(() => {
        setLogs((log) => [
          ` 
      <div class='my-2 bg-green-200'>
        Uploaded ✅ ,
      </div>
    `,
          ...log,
        ]);
      }, 2000);
    });
    fileInstance.onLogged((logged, type) => {
      setLogs((log) => [`<div class='my-2 bg-green-200'>${logged}</div>`, ...log]);
      if (type === "error") {
        new Audio("/igap_signaling.mp3").play();
        setTimeout(() => {
          new Audio("/igap_signaling.mp3").play();
        }, 3000);
        setTimeout(() => {
          new Audio("/igap_signaling.mp3").play();
        }, 6000);
      }
    });
    fileInstance.start();
  };

  return (
    <div
      style={{
        overflowY: "scroll",
      }}
      dir={"ltr"}
    >
      {/*< key={"loader"} page={"sd"} layout={"auth"}>*/}
      {/*<div className="border border-green-200 my-2 p-5">*/}
      {/*  <label className={"text-md font-bold pb-2"}>*/}
      {/*    Async Upload (Stream Encrypt + Stream Upload)*/}
      {/*  </label>*/}
      {/*  <input type="file" onChange={onChangeAsync} />*/}
      {/*</div>*/}

      <div className="border border-red-200 p-5">
        <label className={"text-md font-bold pb-2"}>Upload </label>
        <hr />
        <input type="file" onChange={onChangeFile} />
      </div>

      <hr />
      <br />

      {uploadedFileToken && (
        <div>
          <h1>Token : {uploadedFileToken}</h1>
          <button onClick={onClickDownload}>Download</button>
        </div>
      )}

      <ul
        className={"w-full border border-gray-200"}
        style={{
          height: 500,
          padding: "10px 10px",
          overflowY: "scroll",
        }}
      >
        {logs.map((log) => (
          <li dangerouslySetInnerHTML={{ __html: log }} />
        ))}
      </ul>
      {/*<>{getRouteApp()}</>*/}
      {/*</UiLoader>*/}
    </div>
  );
};
